export const TOGGLE_BUTTON_WIDTH = 130;
export const SHOW_TOGGLE_BUTTON_TRIGGER_HEIGHT = 100;
